"use client";

import { useEffect } from "react";
import { applyAppTheme, getStoredAppTheme } from "@/lib/appTheme";

export default function AppThemeBootstrap() {
  useEffect(() => {
    applyAppTheme(getStoredAppTheme());
  }, []);

  return null;
}
